import { getSnippetContent, type GLSnippet } from '..'

@store()
export class Snippet {
  constructor(private fromApi: GLSnippet) {}
  get id() {
    return this.fromApi.id
  }
  get author() {
    return this.fromApi.author
  }
  get title() {
    return this.fromApi.title
  }
  @lazy(async (s) => getSnippetContent(s.id)) content?: string
}
